import { useI18n } from "@/i18n/I18nProvider";
import { LogoFull, LogoIcon } from "@/components/Logo";
import { Instagram, Twitter, Mail } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  const { t } = useI18n();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050505] border-t border-[#1f1f29] pt-20 pb-8 kh-section-cinematic"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="mb-5">
              <LogoFull height={44} color="#FFFFFF" accent="#D4AF37" jewel="#A93043" />
            </div>
            <p className="font-serif-luxury italic text-2xl text-[#D4AF37] mb-4">
              "{t.footer.tagline}"
            </p>
            <p className="font-body text-sm text-white/55 max-w-sm leading-relaxed">
              {t.footer.blurb}
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                data-testid="footer-instagram"
                className="w-10 h-10 flex items-center justify-center border border-[#1f1f29] text-white hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noreferrer"
                aria-label="Twitter"
                data-testid="footer-twitter"
                className="w-10 h-10 flex items-center justify-center border border-[#1f1f29] text-white hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors"
              >
                <Twitter className="w-4 h-4" />
              </a>
              <a
                href="mailto:hello@kirchero.store"
                aria-label="Email"
                data-testid="footer-email"
                className="w-10 h-10 flex items-center justify-center border border-[#1f1f29] text-white hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors"
              >
                <Mail className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div className="md:col-span-3">
            <h4 className="kh-eyebrow mb-5">{t.footer.shopLinks}</h4>
            <ul className="space-y-3">
              <li><a href="#shop" className="font-body text-sm text-white/80 hover:text-[#D4AF37] transition-colors">T-Shirts</a></li>
              <li><a href="#shop" className="font-body text-sm text-white/80 hover:text-[#D4AF37] transition-colors">Hoodies</a></li>
              <li><a href="#shop" className="font-body text-sm text-white/80 hover:text-[#D4AF37] transition-colors">Caps</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="kh-eyebrow mb-5">{t.footer.info}</h4>
            <ul className="space-y-3">
              <li><a href="#story" className="font-body text-sm text-white/80 hover:text-[#D4AF37] transition-colors">{t.nav.story}</a></li>
              <li><a href="#newsletter" className="font-body text-sm text-white/80 hover:text-[#D4AF37] transition-colors">{t.nav.newsletter}</a></li>
              <li><a href="mailto:hello@kirchero.store" className="font-body text-sm text-white/80 hover:text-[#D4AF37] transition-colors">{t.nav.contact}</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="kh-eyebrow mb-5">{t.footer.legal}</h4>
            <ul className="space-y-3">
              <li><Link to="/impressum" data-testid="footer-link-impressum" className="font-body text-sm text-white/80 hover:text-[#D4AF37] transition-colors">{t.footer.imprint}</Link></li>
              <li><Link to="/datenschutz" data-testid="footer-link-datenschutz" className="font-body text-sm text-white/80 hover:text-[#D4AF37] transition-colors">{t.footer.privacy}</Link></li>
              <li><Link to="/agb" data-testid="footer-link-agb" className="font-body text-sm text-white/80 hover:text-[#D4AF37] transition-colors">{t.footer.terms}</Link></li>
            </ul>
          </div>
        </div>

        <div className="kh-divider-ornament" />

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-body text-xs text-white/40 tracking-[0.1em]">
            © {year} KirchHero. {t.footer.copyright}
          </p>
          <p className="font-serif-luxury italic text-xs text-[#D4AF37]/70">
            Vol. 02 — The Cup Edition · Auto-Deploy 🟢
          </p>
        </div>
      </div>
    </footer>
  );
}
